// extracted by mini-css-extract-plugin
module.exports = {"Root":"adminBuyersOverview_Root__YsmM7","Accepted":"adminBuyersOverview_Accepted__2PF1U","Declined":"adminBuyersOverview_Declined__SOMnD","Icon":"adminBuyersOverview_Icon__j_eQ6"};